export default "__VITE_ASSET__Brzj2T1n__"